(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  let scheduled = false;

  const normalizedText = (element) =>
    (element.value || element.textContent || '').replace(/\s+/g, ' ').trim();

  const ensureNoHoverStyles = () => {
    if (document.getElementById('ApportinoTeeNoHover')) return;

    const style = document.createElement('style');
    style.id = 'ApportinoTeeNoHover';
    style.textContent = `
      #tee-artwork-form .apportino-tee-no-hover {
        transition: none !important;
      }

      #tee-artwork-form .apportino-tee-no-hover:hover {
        animation: none !important;
        background-color: var(--apportino-tee-background-color) !important;
        background-image: var(--apportino-tee-background-image) !important;
        border-color: var(--apportino-tee-border-color) !important;
        box-shadow: var(--apportino-tee-box-shadow) !important;
        color: var(--apportino-tee-color) !important;
        filter: var(--apportino-tee-filter) !important;
        opacity: var(--apportino-tee-opacity) !important;
        text-decoration: var(--apportino-tee-text-decoration) !important;
        transform: var(--apportino-tee-transform) !important;
      }

      #tee-artwork-form .apportino-tee-no-hover:hover *,
      #tee-artwork-form .apportino-tee-no-hover:hover svg {
        color: inherit !important;
        fill: currentColor !important;
        transform: none !important;
      }

      #tee-artwork-form .apportino-tee-no-hover:hover::before {
        background-color: var(--apportino-tee-before-background-color) !important;
        background-image: var(--apportino-tee-before-background-image) !important;
        border-color: var(--apportino-tee-before-border-color) !important;
        box-shadow: var(--apportino-tee-before-box-shadow) !important;
        filter: var(--apportino-tee-before-filter) !important;
        opacity: var(--apportino-tee-before-opacity) !important;
        transform: var(--apportino-tee-before-transform) !important;
      }

      #tee-artwork-form .apportino-tee-no-hover:hover::after {
        background-color: var(--apportino-tee-after-background-color) !important;
        background-image: var(--apportino-tee-after-background-image) !important;
        border-color: var(--apportino-tee-after-border-color) !important;
        box-shadow: var(--apportino-tee-after-box-shadow) !important;
        filter: var(--apportino-tee-after-filter) !important;
        opacity: var(--apportino-tee-after-opacity) !important;
        transform: var(--apportino-tee-after-transform) !important;
      }

      #tee-artwork-form .apportino-tee-add-to-cart,
      #tee-artwork-form .apportino-tee-add-to-cart:hover,
      #tee-artwork-form .apportino-tee-add-to-cart:focus,
      #tee-artwork-form .apportino-tee-add-to-cart:focus-visible,
      #tee-artwork-form .apportino-tee-add-to-cart:active,
      #tee-artwork-form .apportino-tee-add-to-cart[aria-disabled='true'],
      #tee-artwork-form .apportino-tee-add-to-cart[disabled] {
        animation: none !important;
        background: #000 !important;
        border-color: #000 !important;
        box-shadow: none !important;
        color: #fff !important;
        filter: none !important;
        opacity: 1 !important;
        outline-color: #000 !important;
        transform: none !important;
        -webkit-text-fill-color: #fff !important;
      }

      #tee-artwork-form .apportino-tee-add-to-cart *,
      #tee-artwork-form .apportino-tee-add-to-cart:hover *,
      #tee-artwork-form .apportino-tee-add-to-cart:focus *,
      #tee-artwork-form .apportino-tee-add-to-cart:active * {
        color: #fff !important;
        fill: currentColor !important;
        -webkit-text-fill-color: #fff !important;
      }

      #tee-artwork-form .apportino-tee-add-to-cart::before,
      #tee-artwork-form .apportino-tee-add-to-cart::after,
      #tee-artwork-form .apportino-tee-add-to-cart:hover::before,
      #tee-artwork-form .apportino-tee-add-to-cart:hover::after,
      #tee-artwork-form .apportino-tee-add-to-cart:focus::before,
      #tee-artwork-form .apportino-tee-add-to-cart:focus::after,
      #tee-artwork-form .apportino-tee-add-to-cart:active::before,
      #tee-artwork-form .apportino-tee-add-to-cart:active::after {
        background: transparent !important;
        border-color: #000 !important;
        box-shadow: none !important;
        filter: none !important;
        opacity: 1 !important;
        transform: none !important;
      }

      #tee-artwork-form .apportino-tee-preview-button,
      #tee-artwork-form .apportino-tee-preview-button:hover,
      #tee-artwork-form .apportino-tee-preview-button:focus,
      #tee-artwork-form .apportino-tee-preview-button:focus-visible,
      #tee-artwork-form .apportino-tee-preview-button:active,
      #tee-artwork-form .apportino-tee-preview-button[aria-disabled='true'],
      #tee-artwork-form .apportino-tee-preview-button[disabled] {
        animation: none !important;
        background: #fff !important;
        border-color: #000 !important;
        box-shadow: none !important;
        color: #000 !important;
        filter: none !important;
        opacity: 1 !important;
        outline-color: #000 !important;
        transform: none !important;
        -webkit-text-fill-color: #000 !important;
      }

      #tee-artwork-form .apportino-tee-preview-button *,
      #tee-artwork-form .apportino-tee-preview-button:hover *,
      #tee-artwork-form .apportino-tee-preview-button:focus *,
      #tee-artwork-form .apportino-tee-preview-button:active * {
        color: #000 !important;
        fill: currentColor !important;
        -webkit-text-fill-color: #000 !important;
      }

      #tee-artwork-form .apportino-tee-preview-button::before,
      #tee-artwork-form .apportino-tee-preview-button::after,
      #tee-artwork-form .apportino-tee-preview-button:hover::before,
      #tee-artwork-form .apportino-tee-preview-button:hover::after,
      #tee-artwork-form .apportino-tee-preview-button:focus::before,
      #tee-artwork-form .apportino-tee-preview-button:focus::after,
      #tee-artwork-form .apportino-tee-preview-button:active::before,
      #tee-artwork-form .apportino-tee-preview-button:active::after {
        background: transparent !important;
        border-color: #000 !important;
        box-shadow: none !important;
        filter: none !important;
        opacity: 1 !important;
        transform: none !important;
      }
    `;
    document.head.append(style);
  };

  const noHoverSnapshots = new Map();
  const noHoverProperties = [
    ['background-color', 'backgroundColor'],
    ['background-image', 'backgroundImage'],
    ['border-color', 'borderColor'],
    ['box-shadow', 'boxShadow'],
    ['color', 'color'],
    ['filter', 'filter'],
    ['opacity', 'opacity'],
    ['text-decoration', 'textDecoration'],
    ['transform', 'transform']
  ];

  const captureStyleSnapshot = (element, pseudoElement = null) => {
    const computedStyle = window.getComputedStyle(element, pseudoElement);
    return Object.fromEntries(noHoverProperties.map(([property, key]) => [property, computedStyle[key]]));
  };

  const applyStyleSnapshot = (element, prefix, snapshot) => {
    Object.entries(snapshot).forEach(([property, value]) => {
      element.style.setProperty(`--apportino-tee-${prefix}${property}`, value);
    });
  };

  const enforceFixedActionStyle = (element, isAddToCart) => {
    const backgroundColor = isAddToCart ? 'rgb(0, 0, 0)' : 'rgb(255, 255, 255)';
    const textColor = isAddToCart ? 'rgb(255, 255, 255)' : 'rgb(0, 0, 0)';
    const styles = {
      animation: 'none',
      'background-color': backgroundColor,
      'background-image': 'none',
      'border-color': 'rgb(0, 0, 0)',
      'box-shadow': 'none',
      color: textColor,
      filter: 'none',
      opacity: '1',
      transform: 'none',
      transition: 'none',
      '-webkit-text-fill-color': textColor
    };

    Object.entries(styles).forEach(([property, value]) => {
      if (
        element.style.getPropertyValue(property) !== value ||
        element.style.getPropertyPriority(property) !== 'important'
      ) {
        element.style.setProperty(property, value, 'important');
      }
    });
  };

  const syncNoHoverButtons = (artwork) => {
    const selectors = [
      'button',
      'a',
      '[role="button"]',
      'input[type="button"]',
      'input[type="submit"]'
    ].join(',');

    artwork.querySelectorAll(selectors).forEach((element) => {
      const text = normalizedText(element).toLocaleLowerCase('de-DE');
      const className = typeof element.className === 'string' ? element.className : '';
      const isPreview =
        text === 'vorschau' ||
        text === 'preview' ||
        /tee-(?:btn|button).*preview|preview.*tee-(?:btn|button)/i.test(className);
      const isAddToCart =
        text.includes('in den warenkorb') ||
        text === 'add to cart' ||
        /tee-(?:btn|button).*(?:atc|cart)|(?:atc|cart).*tee-(?:btn|button)/i.test(className);

      if (!isPreview && !isAddToCart) return;

      element.classList.add('apportino-tee-no-hover');
      if (isAddToCart) element.classList.add('apportino-tee-add-to-cart');
      if (isPreview) element.classList.add('apportino-tee-preview-button');
      enforceFixedActionStyle(element, isAddToCart);

      if (element.dataset.apportinoNoHover === 'true') return;

      const snapshotKey = isPreview ? 'preview' : 'add-to-cart';
      let snapshot = noHoverSnapshots.get(snapshotKey);

      if (!snapshot) {
        snapshot = {
          normal: captureStyleSnapshot(element),
          before: captureStyleSnapshot(element, '::before'),
          after: captureStyleSnapshot(element, '::after')
        };
        noHoverSnapshots.set(snapshotKey, snapshot);
      }

      applyStyleSnapshot(element, '', snapshot.normal);
      applyStyleSnapshot(element, 'before-', snapshot.before);
      applyStyleSnapshot(element, 'after-', snapshot.after);
      element.dataset.apportinoNoHover = 'true';
    });
  };
  const tooltipAttributes = [
    'title',
    'aria-label',
    'data-tooltip',
    'data-original-title',
    'data-tippy-content',
    'data-tip',
    'data-balloon',
    'data-tooltip-content'
  ];
  const observedAttributes = [
    ...tooltipAttributes,
    'aria-disabled',
    'class',
    'disabled',
    'style'
  ];

  const stripTeeinblueTooltip = (root) => {
    if (!root) return;

    [root, ...root.querySelectorAll('*')].forEach((element) => {
      tooltipAttributes.forEach((attribute) => element.removeAttribute(attribute));
    });
  };

  const removeTeeinblueTooltipNodes = (colorValues, artwork) => {
    const selectors = [
      '.tee-tooltip',
      '.tee-tooltip-content',
      '.tippy-box',
      '.tippy-popper',
      '[data-tippy-root]',
      '[role="tooltip"]'
    ].join(',');

    const candidates = new Set([
      ...artwork.querySelectorAll(selectors),
      ...document.querySelectorAll('.tippy-box, .tippy-popper, [data-tippy-root], [role="tooltip"]')
    ]);

    candidates.forEach((element) => {
      if (element.classList.contains('apportino-tee-tooltip')) return;
      const tooltipText = normalizedText(element);
      if (!colorValues.has(tooltipText)) return;
      const tooltipRoot = element.closest('[data-tippy-root], .tippy-popper') || element;
      tooltipRoot.remove();
    });
  };

  let tooltipTimer = 0;
  let tooltipPointerX = 0;
  let tooltipPointerY = 0;

  const getApportinoTooltip = () => {
    let tooltip = document.querySelector('body > .apportino-tee-tooltip');
    if (!tooltip) {
      tooltip = document.createElement('span');
      tooltip.className = 'apportino-tee-tooltip';
      tooltip.hidden = true;
      document.body.append(tooltip);
    }
    return tooltip;
  };

  const positionApportinoTooltip = (tooltip) => {
    const horizontalGap = 16;
    const verticalGap = 18;
    const viewportGap = 4;
    const bounds = tooltip.getBoundingClientRect();
    let left = tooltipPointerX + horizontalGap;
    let top = tooltipPointerY + verticalGap;

    if (left + bounds.width > window.innerWidth - viewportGap) {
      left = tooltipPointerX - bounds.width - horizontalGap;
    }

    if (top + bounds.height > window.innerHeight - viewportGap) {
      top = tooltipPointerY - bounds.height - verticalGap;
    }

    tooltip.style.left = Math.max(viewportGap, left) + 'px';
    tooltip.style.top = Math.max(viewportGap, top) + 'px';
  };

  const updateTooltipPointer = (event) => {
    tooltipPointerX = event.clientX;
    tooltipPointerY = event.clientY;
    const tooltip = document.querySelector('body > .apportino-tee-tooltip');
    if (tooltip && !tooltip.hidden) positionApportinoTooltip(tooltip);
  };

  const showApportinoTooltip = (value, event) => {
    if (!window.matchMedia('(hover: hover)').matches) return;

    window.clearTimeout(tooltipTimer);
    updateTooltipPointer(event);

    const tooltip = getApportinoTooltip();
    tooltip.textContent = value;
    tooltip.hidden = true;

    tooltipTimer = window.setTimeout(() => {
      tooltip.hidden = false;
      positionApportinoTooltip(tooltip);
    }, 500);
  };

  const hideApportinoTooltip = () => {
    window.clearTimeout(tooltipTimer);
    const tooltip = document.querySelector('body > .apportino-tee-tooltip');
    if (tooltip) tooltip.hidden = true;
  };

  const syncColorControl = (input, selectedColor, colorOption) => {
    const container = input.closest('.tee-radio, .tee-swatch') || input.parentElement;
    if (!container) return '';

    const label =
      Array.from(input.labels || []).find((item) => colorOption.contains(item)) ||
      container.querySelector('label');

    if (!label) return input.value || '';

    const optionValue =
      input.value ||
      label.dataset.value ||
      label.getAttribute('title') ||
      normalizedText(label);

    stripTeeinblueTooltip(container);

    container.classList.add('apportino-tee-color-control');
    label.classList.add('apportino-tee-color-label');

    const isSelected =
      Boolean(input.checked) ||
      container.classList.contains('active') ||
      Boolean(optionValue && selectedColor && optionValue === selectedColor);

    container.classList.toggle('apportino-tee-selected', isSelected);
    label.classList.toggle('apportino-tee-selected', isSelected);
    const swatch =
      label.querySelector('.tee-swatch--color') ||
      Array.from(label.children).find(
        (element) =>
          element.tagName === 'SPAN' &&
          !element.classList.contains('apportino-tee-tooltip')
      );

    if (swatch) {
      swatch.classList.add('apportino-tee-color-disc');
      swatch.style.setProperty('border', '0.1rem solid rgba(var(--color-foreground), 0.15)', 'important');
      swatch.style.setProperty('box-shadow', 'none', 'important');
      swatch.style.setProperty('outline', '0', 'important');
    }

    label.querySelector(':scope > .apportino-tee-tooltip')?.remove();

    if (!label.dataset.apportinoTooltipBound) {
      label.dataset.apportinoTooltipBound = 'true';
      label.addEventListener('mouseenter', (event) => {
        showApportinoTooltip(optionValue, event);
      });
      label.addEventListener('mousemove', updateTooltipPointer);
      label.addEventListener('mouseleave', hideApportinoTooltip);
    }

    return optionValue;
  };

  const syncProductInfo = (productInfo) => {
    const artwork = productInfo.querySelector('#tee-artwork-form');
    if (!artwork) return;

    syncNoHoverButtons(artwork);

    const infoContainer = productInfo.querySelector('.product__info-container');
    if (infoContainer) {
      let teePriceBlock = artwork;
      while (teePriceBlock.parentElement && teePriceBlock.parentElement !== infoContainer) {
        teePriceBlock = teePriceBlock.parentElement;
      }
      if (teePriceBlock.parentElement === infoContainer) {
        teePriceBlock.classList.add('apportino-tee-price-block');
      }
    }

    const price = artwork.querySelector('.tee-product-price');
    const currentPrice = price?.querySelector('.tee-price--current');

    if (price && currentPrice) {
      const currentPriceText = normalizedText(currentPrice);
      if (/^€\s*/.test(currentPriceText)) {
        currentPrice.textContent = currentPriceText.replace(/^€\s*/, '').trim() + '€';
      }

      artwork.querySelectorAll('div, p, span, small').forEach((element) => {
        if (
          !element.classList.contains('apportino-tee-tax') &&
          normalizedText(element).toLocaleLowerCase('de-DE') === 'inkl. mwst.'
        ) {
          element.hidden = true;
        }
      });

      price.querySelectorAll('.tee-price-wrapper').forEach((wrapper) => {
        wrapper.classList.toggle('apportino-tee-current-price', wrapper.contains(currentPrice));
      });

      let tax = price.querySelector('.apportino-tee-tax');
      if (!tax) {
        tax = document.createElement('span');
        tax.className = 'apportino-tee-tax';
        tax.textContent = 'inkl. MwSt.';
      }

      currentPrice.insertAdjacentElement('afterend', tax);

      const productTitle = infoContainer?.querySelector(':scope > .product__title');
      if (productTitle) {
        const desiredPriceTop = productTitle.getBoundingClientRect().bottom + 5;
        const currentPriceTop = price.getBoundingClientRect().top;
        const correction = desiredPriceTop - currentPriceTop;

        if (Math.abs(correction) > 0.5) {
          const currentArtworkMargin = Number.parseFloat(window.getComputedStyle(artwork).marginTop) || 0;
          artwork.style.setProperty(
            'margin-top',
            Math.round((currentArtworkMargin + correction) * 10) / 10 + 'px',
            'important'
          );
          window.requestAnimationFrame(scheduleSync);
        }
      }
    }

    const colorOption = artwork.querySelector('.tee-option--color');
    const highlights = productInfo.querySelector('.ap-teeinblue-highlights');

    if (colorOption && highlights && window.matchMedia('(max-width: 749px)').matches) {
      const currentMargin = Number.parseFloat(window.getComputedStyle(colorOption).marginTop) || 0;
      const correction = highlights.getBoundingClientRect().bottom - colorOption.getBoundingClientRect().top;
      const correctedMargin = Math.max(0, currentMargin + correction);
      const roundedMargin = Math.round(correctedMargin * 10) / 10;

      if (Math.abs(correction) > 0.5) {
        colorOption.style.setProperty('margin-top', roundedMargin + 'px', 'important');
        colorOption.dataset.apportinoMobileSpacing = 'true';
        window.requestAnimationFrame(scheduleSync);
      }
    } else if (colorOption?.dataset.apportinoMobileSpacing === 'true') {
      colorOption.style.removeProperty('margin-top');
      delete colorOption.dataset.apportinoMobileSpacing;
      window.requestAnimationFrame(scheduleSync);
    }

    const colorTitle = colorOption?.querySelector(':scope > .tee-option__title');
    const activeColorInput = colorOption?.querySelector(
      '.tee-radio.active input[type="radio"], .tee-swatch.active input[type="radio"]'
    );
    const checkedColorInput = colorOption?.querySelector('input[type="radio"]:checked');
    const selectedColor = activeColorInput?.value || checkedColorInput?.value || '';

    if (colorTitle) {
      colorTitle.classList.add('form__label');
      if (colorTitle.dataset.apportinoValue !== selectedColor) {
        colorTitle.replaceChildren(document.createTextNode('Farbe:'));
        if (selectedColor) {
          const selectedValue = document.createElement('span');
          selectedValue.className = 'apportino-tee-selected-value';
          selectedValue.textContent = selectedColor;
          colorTitle.append(selectedValue);
        }
        colorTitle.dataset.apportinoValue = selectedColor;
      }

      colorTitle.dataset.apportinoForceBlackVariantLabel = 'true';
      colorTitle.style.setProperty('color', '#000000', 'important');
      colorTitle.style.setProperty('-webkit-text-fill-color', '#000000', 'important');
      colorTitle.style.setProperty('opacity', '1', 'important');
      colorTitle.querySelectorAll('*').forEach((element) => {
        element.style.setProperty('color', '#000000', 'important');
        element.style.setProperty('-webkit-text-fill-color', '#000000', 'important');
        element.style.setProperty('opacity', '1', 'important');
      });
    }

    if (colorOption) {
      const colorValues = new Set();
      colorOption.querySelectorAll('input[type="radio"]').forEach((input) => {
        const optionValue = syncColorControl(input, selectedColor, colorOption);
        if (optionValue) colorValues.add(optionValue);
      });
      removeTeeinblueTooltipNodes(colorValues, artwork);
    }

    const sizeOption = artwork.querySelector('.tee-option--size');
    if (sizeOption) {
      let sizeTitle = sizeOption.querySelector(':scope > .tee-option__title');
      let sizeHeading = sizeOption.querySelector(':scope > .apportino-tee-size-heading');

      if (!sizeHeading && sizeTitle) {
        sizeHeading = document.createElement('div');
        sizeHeading.className = 'apportino-tee-size-heading';
        sizeTitle.before(sizeHeading);
        sizeHeading.append(sizeTitle);
      } else if (sizeHeading) {
        sizeTitle ||= sizeHeading.querySelector('.tee-option__title');
      }

      if (sizeTitle) {
        sizeTitle.classList.add('form__label');
        if (normalizedText(sizeTitle) !== 'Größe:') sizeTitle.textContent = 'Größe:';

        sizeTitle.dataset.apportinoForceBlackVariantLabel = 'true';
        sizeTitle.style.setProperty('color', '#000000', 'important');
        sizeTitle.style.setProperty('-webkit-text-fill-color', '#000000', 'important');
        sizeTitle.style.setProperty('opacity', '1', 'important');
      }

      const openerTemplate = productInfo.querySelector('.tee-size-chart-host modal-opener');
      if (
        sizeHeading &&
        openerTemplate &&
        !sizeHeading.querySelector('.apportino-tee-size-chart')
      ) {
        const opener = openerTemplate.cloneNode(true);
        opener.classList.add('apportino-tee-size-chart');
        opener.hidden = false;
        opener.removeAttribute('hidden');
        opener.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        sizeHeading.append(opener);
      }

    }

    if (!artwork.dataset.apportinoLayoutBound) {
      const suppressTooltipBeforeHover = (event) => {
        const control = event.target.closest(
          '.tee-option--color .tee-radio, .tee-option--color .tee-swatch'
        );
        if (control && artwork.contains(control)) stripTeeinblueTooltip(control);
      };

      artwork.dataset.apportinoLayoutBound = 'true';
      artwork.addEventListener('change', () => window.setTimeout(scheduleSync, 0));
      artwork.addEventListener('pointerover', suppressTooltipBeforeHover, true);
      artwork.addEventListener('mouseover', suppressTooltipBeforeHover, true);
    }
  };

  const syncPreviewCloseButtons = () => {
    document.querySelectorAll('button, a, [role="button"]').forEach((element) => {
      if (normalizedText(element).toLocaleLowerCase('de-DE') === 'vorschau schließen') {
        element.classList.add('apportino-tee-preview-close');
      }
    });
  };

  const syncAll = () => {
    document.querySelectorAll('product-info').forEach(syncProductInfo);
    syncPreviewCloseButtons();
  };

  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      syncAll();
    });
  };

  const start = () => {
    ensureNoHoverStyles();
    const observer = new MutationObserver(scheduleSync);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: observedAttributes,
      characterData: true,
      childList: true,
      subtree: true
    });
    window.addEventListener('resize', scheduleSync);
    scheduleSync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
